import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Customers from "assets/svgs/customers";
import { getColor } from "helpers/utils";
import { Card, Col, Row } from "react-bootstrap";
import ActiveCustomers from "assets/svgs/active_customers";
import LostCustomer from "assets/svgs/lost_customer";
import ReactEChartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";
import CountUp from "react-countup";
import CardColumns from "modules/common/card-columns/CardColumns";
import Orders from "assets/svgs/orders";
import Revenue from "assets/svgs/revenue";
import AOV from "assets/svgs/aov";
import CardDiv from "modules/common/card-div/CardDiv";
import NewOrder from "assets/svgs/new_order";
import RepeatOrder from "assets/svgs/repeat_order";

// const getOptions = (data) => ({
//   series: [
//     {
//       type: "gauge",
//       startAngle: 90,
//       endAngle: -270,
//       radius: "90%",
//       pointer: {
//         show: false,
//       },
//       progress: {
//         show: true,
//         overlap: false,
//         roundCap: true,
//         clip: false,
//         itemStyle: {
//           color: getColor("primary"),
//         },
//       },
//       axisLine: {
//         lineStyle: {
//           width: 8,
//           color: [[1, getColor("gray-200")]],
//         },
//       },
//       splitLine: {
//         show: false,
//       },
//       axisTick: {
//         show: false,
//       },
//       axisLabel: {
//         show: false,
//       },
//       data: [
//         {
//           value: data,
//           detail: {
//             offsetCenter: ["7%", "4%"],
//           },
//         },
//       ],
//       detail: {
//         width: 50,
//         height: 14,
//         fontSize: 28,
//         fontWeight: 500,
//         fontFamily: "poppins",
//         color: getColor("gray-500"),
//         formatter: "{value}%",
//       },
//     },
//   ],
// });





 const EngagementCard = ({ data, orderCount, orderRevenue, orderAov ,orderProgress, summary}) => {
  const statsData = [
    {
      title: "Total Customers",
      amount: data.cases,
      caret: "caret-up",
      color: "primary",
      icon: <Customers />,
      caretColor: "success",
    },
    {
      title: "Active Customers",
      amount: data.active_cases,
      caret: "caret-up",
      color: "info",
      icon: <ActiveCustomers />,
      caretColor: "success",
    },
    {
      title: "Lost Customers",
      amount: data.inactive_cases,
      caret: "caret-down",
      color: "success",
      icon: <LostCustomer />,
      caretColor: "danger",
    },
  ];

  const orderData = [
    {
      title: "Order",
      amount: orderCount||"0",
      caret: "caret-up",
      color: "primary",
      icon: <Orders />,
      caretColor: "success",
    },
    {
      title: "Revenue",
      amount: orderRevenue||"0",
      caret: "caret-up",
      color: "info",
      icon: <Revenue />,
      caretColor: "success",
    },
    {
      title: "AOV",
      amount: orderAov||"0",
      caret: "caret-up",
      color: "success",
      icon: <AOV />,
      caretColor: "info",
    },
  ];
  useEffect(() => {}, [data]);

  const getOptions = (data) => ({
    series: [
      {
        type: "gauge",
        startAngle: 90,
        endAngle: -270,
        radius: "80%",
        pointer: {
          show: false,
        },
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          itemStyle: {
            color: getColor("info"),
          },
        },
        axisLine: {
          lineStyle: {
            width: 8,
            color: [[1, getColor('secondary')]],
          },
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        data: [
          {
            value: data,
            detail: {
              offsetCenter: ["7%", "4%"],
            },
          },
        ],
        detail: {
          width: 50,
          height: 14,
          fontSize: 28,
          fontWeight: 500,
          fontFamily: "poppins",
          color: getColor("gray-500"),
          formatter: "{value}%",
        },
      },
    ],
  });

  
  useEffect(() => {}, [data]);

  
  return (
    <>
      <Row className="d-flex ">
        <Col md={6} xxl={7}
          // style={{ flex: 1 }}
          className="d-flex flex-column h-100 pe-4 ps-1 gap-4 mb-3"
        >
          <Row className=" ms-1 flex-1">
            <CardColumns data={data} statsData={statsData} />
          </Row>
          <Row className=" ms-1 flex-1">
            <CardColumns data={data} statsData={orderData} />
          </Row>
        </Col>
        <Col md={6} xxl={5}
        className="mb-3 mx-0 ps-1 d-flex justify-content-between gap-3 flex-wrap">
          <div className="flex-1">
            <CardDiv
              title={"Engagement Status"}
              component={
                <ReactEChartsCore
                  echarts={echarts}
                  option={getOptions(+summary.percentage)}
                  style={{ height: "100%" }}
                />
              }
            />
          </div>
          <div className="flex-1">
            <CardDiv
              title={"In Progress Orders"}
              component={
                <div className="d-flex flex-column  ">
                  <Row>
                    <h5 className="d-flex gap-2 align-items-center py-3">
                      <NewOrder />{" "}
                      <p className="mx-2 me-5  d-flex w-100 justify-content-between">
                        <span>New Order</span>
                        <span className="align-self-end">{orderProgress?.new}</span>
                      </p>
                    </h5>
                  </Row>
                  <Row>
                    <h5 className="d-flex gap-2 align-items-center py-3">
                      <RepeatOrder />{" "}
                      <p className=" me-5  d-flex w-100 justify-content-between">
                        <span>Repeat Order</span>
                        <span className="align-self-end">{orderProgress?.repeat}</span>
                      </p>
                    </h5>
                  </Row>
                </div>
              }
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default EngagementCard;
